import { fork } from "redux-saga/effects";
import watchAddUser from "./adduser/watcher";
import watchAsset from "./asset/watcher";
import watchEmployee from "./employee/watcher";
import watchInventory from "./inventory/watcher";
import watchUserAuthentication from "./signin/watcher";
import watchSignUp from "./signup/watcher";
import watchStore from "./store/watcher";
import watchSupplier from "./supplier/watcher";
import watchLicense from "./license/watcher";
import watchPhysicalInventory from "./physicalInventory/watcher";
import watchNonSaleableReturn from "./nonsaleablereturn/watcher";

export default function* startForman() {
  yield fork(watchUserAuthentication);
  yield fork(watchSignUp);
  yield fork(watchAddUser);
  yield fork(watchEmployee);
  yield fork(watchAsset);
  yield fork(watchSupplier);
  yield fork(watchInventory);
  yield fork(watchStore);
  yield fork(watchLicense);
  yield fork(watchPhysicalInventory);
  yield fork(watchNonSaleableReturn);
}
